exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select[data-v-7e5f832f] {\n  min-width: 200px;\n}\n[data-v-7e5f832f] .vs__selected-options {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n[data-v-7e5f832f] .vs__dropdown-menu {\n  min-width: -webkit-fit-content;\n  min-width: -moz-fit-content;\n  min-width: fit-content;\n}\n.filter-inline[data-v-7e5f832f]  .md-field {\n  display: inline-block;\n  width: 200px;\n  margin-right: 20px;\n}\n", ""]);

// exports
